import { Component, OnInit } from '@angular/core';
import { faTimes } from '@fortawesome/pro-light-svg-icons';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { FlyerService } from '@clooper/core';

@Component({
  selector: 'app-remove-membership-modal',
  templateUrl: './remove-membership-modal.component.html',
  styleUrls: ['./remove-membership-modal.component.scss']
})
export class RemoveMembershipModalComponent implements OnInit {
  icons = { close: faTimes };
  membershipId: string;
  submitting = false;
  onRemoved: () => void;

  constructor(
    public bsModalRef: BsModalRef,
    private flyerService: FlyerService
  ) {}

  ngOnInit(): void {}

  close(): void {
    this.bsModalRef?.hide();
  }

  confirm(): void {
    if (!this.membershipId || this.submitting) return;

    this.submitting = true;
    this.flyerService.deleteFlyerFullResponse(this.membershipId).subscribe({
      next: () => {
        this.submitting = false;
        if (this.onRemoved) this.onRemoved();
        this.close();
      },
      error: () => {
        this.submitting = false;
      }
    });
  }
}
